import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";
import { tags } from "../../consts/Tags";
import ButtonRounded from "../global/buttons/ButtonRounded";
import ButtonText from "../global/buttons/ButtonText";
import InputText from "../global/InputText";
import PopUpRouge from "../global/popup/PopUpRouge";
import SauvegardeManager from "../SauvegardeManager";

export default class NewGamePanel extends Phaser.GameObjects.Container {
    constructor(scene, x, y, closeFunction) {
        super(scene, x, y);
        this.scene = scene;
        scene.add.existing(this);

        this.sauvegardeManager = new SauvegardeManager();
        this.closeFunction = closeFunction;

        // Ajout du fond
        let background = this.scene.add.rectangle(0, -4, 1045, this.scene.height +4, Colors.Elmt.Orange).setOrigin(0, 0);
        background.setStrokeStyle(4, Colors.Elmt.White)
        this.add(background)

        let bande = this.scene.add.rectangle(140, 0, background.width - 140, this.scene.height, Colors.Elmt.DarkBlue).setOrigin(0, 0);
        this.add(bande)

        let textBande = this.scene.add.text(bande.x/2, background.height/2, "NOUVELLE PARTIE", {
            fontSize: "125px",
            fontFamily: FONTS.InterSemiBold,
            color: Colors.Text.White,
            letterSpacing: -5
        }).setOrigin(0.5)
        textBande.setAngle(-90)
        textBande.setAlpha(0.22)
        this.add(textBande)

        // Ajout bouton retour
        let retourButton = new ButtonText(this.scene, 240, 70, {text: "Retour", textColor: Colors.Text.White, textHoverColor: Colors.Text.Grey})
        retourButton.addInconOnLeft('icon_fleche', 10, 0.7, true)
        retourButton.setClickFunction( () => {
            this.onClickClose()
        })
        this.add(retourButton)

        // Ajout texte

        this.container = this.scene.add.container(bande.x + bande.width/2, 360)
        this.add(this.container)

        let textTitle = this.scene.add.rexTagText(0, 0, "Choisissez un identifiant unique pour\ndébuter une <class=\"Inter28BoldItalic\">nouvelle enquête.</class>", {
            fontSize: "32px",
            fontFamily: FONTS.Inter28MediumItalic,
            color: Colors.Text.White,
            align: "center",
            tags: tags
        }).setOrigin(0.5, 0)
        this.container.add(textTitle)

        // Ajout champs de saisie
        this.inputText = new InputText(this.scene, 0, textTitle.y + textTitle.height + 30 + 32, {
            placeholder: "Entrez votre identifiant...",
            width: 400,
            height: 64
        })
        this.container.add(this.inputText)

        this.inputText.setOnUpdateFunction( (elmt, text) => {
            if(text.length > 0){
                this.validateButton.setUnlocked();
            } else {
                this.validateButton.setLocked();
            }
        })

        // Ajout sous titre
        let subTitle = this.scene.add.text(0, this.inputText.y + this.inputText.height/2 + 24, "Gardez-le précieusement : il vous servira à revenir\nplus tard dans votre partie.", {
            fontSize: "20px",
            fontFamily: FONTS.Inter18Italic,
            color: Colors.Text.White,
            align: "center",
        }).setOrigin(0.5, 0)
        this.container.add(subTitle)

        // Ajout bouton de validation
        this.validateButton = new ButtonRounded(this.scene, 0, subTitle.y + subTitle.height + 45 + 20, {
            text: "Démarrer une nouvelle partie", 
            color: Colors.Elmt.White,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.DarkBlue, 
            textHoverColor: Colors.Text.Blue
        })
        this.container.add(this.validateButton)
        this.validateButton.setLocked()
        this.validateButton.setClickFunction( () => {
            this.onClickLogin()
        })

        // Ajout logo
        let logo = this.scene.add.image(this.container.x, background.height - 40, 'menu_titre').setOrigin(0.5, 1)
        logo.setScale(0.35)
        this.add(logo)
    }

    onClickLogin(){
        this.sauvegardeManager.setLogin(this.inputText.getInputTextValue());

        this.sauvegardeManager.doPlayerExistsOnDatabase((exists) => {
            if(exists){
                console.log("Player does exist, create new one");
                this.displayError();
            }else{
                this.sauvegardeManager.createOnDatabase();
                localStorage.setItem('login', this.inputText.getInputTextValue());
                this.scene.scene.start('Chapitre1')
            }
        });
    }

    onClickClose(){
        this.closeFunction();
    }

    displayError(){
        this.validateButton.setLocked();
        this.inputText.setInputTextValue("Entrez votre identifiant...");

        this.popup = new PopUpRouge(this.scene, this.container.x, this.scene.height/2, 570, 400);
        this.add(this.popup)

        let textElmt = this.scene.add.rexTagText(0, 0, "<class=\"Inter28BoldItalic\">Cet identifiant existe déjà !</class>\nMerci d’en choisir un autre pour\ncréer votre partie.",{
            fontSize: "28px",
            fontFamily: FONTS.Inter28MediumItalic,
            align: "center",
            lineSpacing: 10,
            color: Colors.Text.White,
            tags: tags,
        })
        textElmt.setOrigin(0.5, 0)
        this.popup.addElementToBody(textElmt, 40)

        let button = new ButtonRounded(this.scene, 0, 0, {
            text: "J’ai compris",
            color: Colors.Elmt.White,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue
        })
        this.popup.addElementToBody(button, 40 + button.height/2)
        button.setClickFunction( () => {
            this.popup.animOut(() => {                    
                this.popup.destroy(true);
            })
        })

        this.popup.animIn()
    }

}